import Vue from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import VueCsrf from 'vue-csrf';
Vue.use(VueCsrf);
// console.log(Vue.csrf.get());
import axios from 'axios';
// Guard anti-duplicato (doppio click -> doppio inserimento): annulla le richieste mutanti
// con stessa firma gia' in volo e allega un header Idempotency-Key per il backend.
import { installAxiosGuard } from './plugins/axiosGuard';
installAxiosGuard(axios);
// Sessione revocata (cambio password / esci da tutti i dispositivi / utente disattivato): logout e redirect
import { installSessionGuard } from './plugins/sessionGuard';
installSessionGuard(axios, store, router);
/*console.log(Vue.csrf.get());
axios.interceptors.request.use(function (config) {
	console.log(config.header);
});*/

import VueLodash from 'vue-lodash';
import lodash from 'lodash';
Vue.use(VueLodash, { name: 'custom', lodash: lodash });

import Vuex from 'vuex';
Vue.use(Vuex);

// Mixin globale per i download asincroni: this.exportAsync(type, format, filters)
import exportAsyncMixin from './mixins/exportAsync';
Vue.mixin(exportAsyncMixin);

import VueYouTubeEmbed from 'vue-youtube-embed';
Vue.use(VueYouTubeEmbed);

import VueMoment from 'vue-moment';
Vue.use(VueMoment);

import { VueMaskDirective } from 'v-mask';
Vue.directive('mask', VueMaskDirective);

import VueSocketio from 'vue-socket.io';
Vue.use(
	new VueSocketio({
		debug: true,
		connection: process.env.VUE_APP_URL_SOCKET,
		vuex: {
			store,
			actionPrefix: 'SOCKET_',
			mutationPrefix: 'SOCKET_',
		},
	}),
);


var filter = function (text, length, clamp) {
	clamp = clamp || '...';
	var node = document.createElement('div');
	node.innerHTML = text;
	var content = node.textContent;
	return content.length > length ? content.slice(0, length) + clamp : content;
};

Vue.filter('truncate', filter);

import vuetify from './plugins/vuetify';

/*import { TiptapVuetifyPlugin } from 'tiptap-vuetify'
import 'tiptap-vuetify/dist/main.css'
Vue.use(TiptapVuetifyPlugin, {
	// the next line is important! You need to provide the Vuetify Object to this place.
	vuetify, // same as "vuetify: vuetify"
	// optional, default to 'md' (default vuetify icons before v2.0.0)
	iconsGroup: 'md'
})*/


import Print from 'vue-print-nb'
Vue.use(Print);

if (process.env.NODE_ENV === 'production') {
	Vue.config.silent = true;
	Vue.config.devtools = false;
	Vue.config.productionTip = false;
} else if (process.env.NODE_ENV === 'development') {
	/*Vue.config.silent = false
    Vue.config.devtools = true
    Vue.config.productionTip = true*/
	Vue.config.silent = true;
	Vue.config.devtools = true;
	Vue.config.productionTip = false;
}

import { setupComponents } from './config';
setupComponents(Vue);
/*Vue.config.debug = true;
Vue.config.devtools = true*/
new Vue({
	router,
	store,
	beforeCreate() {
		store.commit('socket/setSocket', this.$socket);
	},
	vuetify,
	axios,
	VueYouTubeEmbed,
	render: h => h(App),
}).$mount('#app');
